<template>
  <Card class="p-4 border-b-4 border-h-primary-800 custom-card mt-4">
    <template #header>
      <h6>
        {{ $t("labels.generic", { pt: "Adicionais", en: "Additionals" }) }}
      </h6>
    </template>
    <template #content>
      <div class="flex flex-row gap-3 flex-wrap">
        <p v-for="(option, index) in options" :key="index" class="options">
          {{ option.name }}
        </p>
      </div>
    </template>
    <template #footer>
      <span class="flex flex-row-reverse w-full">
        <Button
          :id="`card-item-edit-btn`"
          class="btn-simple w-fit !p-0 !px-2"
          @click="onEdit()"
        >
          <v-icon name="hi-solid-pencil" />
          <p>{{ $t("labels.edit") }}</p>
        </Button>
        <Button class="btn-delete w-fit" @click="confirmDeleteModal()">
          <v-icon name="md-delete" />
          <p>{{ $t("labels.delete") }}</p>
        </Button>
      </span>
    </template>
  </Card>
  <ConfirmDialog
    group="options-card"
    class="custom-dialog"
    :draggable="false"
    :style="{ width: '80vw', maxWidth: '700px' }"
  />
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { OptionInput } from "./FormOptions.vue";
import { useQuizQuestionsDragNDropStore } from "@/store/quiz-question-drag";

export default defineComponent({
  name: "options-card",
  emits: ["editOptions"],
  data() {
    return {
      questionStore: useQuizQuestionsDragNDropStore,
    };
  },
  props: {
    options: {
      type: Array as PropType<Array<OptionInput>>,
      default: [],
    },
  },
  methods: {
    onEdit() {
      this.$emit("editOptions");
    },
    onDelete() {
      this.questionStore.options.length = 0;
    },
    confirmDeleteModal(): void {
      this.$confirm.require({
        group: "options-card",
        message: this.$t("labels.generic", {
          pt: "Deseja deletar deletar todas as respostas adicionais?",
          en: "Do you want to delete all the aditional options?",
        }),
        header: this.$t("labels.generic", {
          pt: "Deletar opções adicionais",
          en: "Delete aditional options",
        }),
        acceptLabel: this.$t("labels.generic", { pt: "Sim", en: "Yes" }),
        rejectLabel: this.$t("labels.generic", { pt: "Não", en: "No" }),
        rejectClass: "btn-simple",
        acceptClass: "btn-delete-block",
        accept: () => {
          this.onDelete();
        },
      });
    },
  },
});
</script>
<style lang="scss">
.custom-card {
  .options {
    background-color: #f6fafd;
    border-radius: 0.4rem;
    border: 1px solid #79b5e1;
    box-decoration-break: clone;
    color: #79b5e1;
    padding: 0.1rem 0.3rem;
  }
}
.custom-dialog {
  .p-dialog-content {
    min-height: 100px;
  }
}
</style>
